import { useEffect, useState } from "react";
import {useSearchParams} from 'react-router-dom';
import sortBy from "lodash/sortBy";
import uniqBy from "lodash/uniqBy";

import PublicLayout from "../layouts/PublicLayout";
import ProviderSearchEmbedScreen from "../../components/embed/ProviderSearchEmbedScreen";
import useDebouncedState from "../../hooks/useDebouncedState";
import { useGetProvidersQuery } from "../../redux/services/providerApi";
import { useGetHighlightsQuery } from "../../redux/services/providerHighlightApi";

const handleFilterChange = ({setFilter, pageIndex, pageSize, uuid}) => (e, filter) => {
  setFilter({
    ...filter,
    include_reviews: true,
    is_hidden: false,
    skip: pageIndex * pageSize,
    limit: pageSize,
    sort: '-search_rank',
    is_publicly_searchable: true,
    save_search: true,
    search_uuid: uuid,
  });
};

const generateUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

const EmbedProviderSearch = props => {
  const [pageSize, setPageSize] = useState(100);
  const [pageIndex, setPageIndex] = useState(0);
  const [uuid] = useState(generateUuid());
  const [search] = useSearchParams();
  let initialState = {};
  if (search.get('text')) initialState.text = search.get('text');
  if (search.get('specialty')) initialState.specialty = search.get('specialty');
  console.log('initialState', initialState);
  const [filter, setFilter] = useState({
    is_hidden: false,
    include_reviews: true,
    skip: pageIndex * pageSize, 
    limit: pageSize,
    is_publicly_searchable: true,
    // sort: 'user__last_name',
    sort: '-search_rank',
    save_search: true,
    search_uuid: uuid,
    ...initialState,
  });
  const [debouncedFilter, setDebouncedFilter] = useState(filter);
  useDebouncedState(filter, setDebouncedFilter, {delay: 500});
  const filterUpdating = debouncedFilter?.text !== filter?.text;
  const providersQuery = useGetProvidersQuery(debouncedFilter, {skip: !debouncedFilter?.text});
  const highlightsQuery = useGetHighlightsQuery();
  const childProps = {
    providers: uniqBy(providersQuery?.data || [], 'id'),
    highlights: (highlightsQuery?.data || []).filter(h => h?.category === 'HIGHLIGHT'),
    loading: providersQuery.isLoading || highlightsQuery.isLoading,
    updating: (
      providersQuery.isFetching 
      || highlightsQuery.isFetching
      || filterUpdating
    ),
    filter,
    hasQueryParams: search.get('text') || search.get('specialty'),
    onFilterChange: handleFilterChange({setFilter, pageSize, pageIndex, uuid}),
    backgroundColor: 'rgb(245, 251, 255)',
    inApp: search.get('inApp') === 'true',
  };
  return (
    <ProviderSearchEmbedScreen {...childProps} />
  );
};

export default EmbedProviderSearch;